/** External Geofleet app URLs, kept in one place so the nav and pages link to the same targets. */
export const HELP_CENTER_URL = 'https://app.geofleet.ai/support';
/** API reference inside the app; requires signing in to a Geofleet account. */
export const API_DOCS_URL = 'https://app.geofleet.ai/support/api-doc';
export const SIGNUP_URL = 'https://app.geofleet.ai/signup';
/** Geofleet Lite sign-up (separate Lite app). */
export const LITE_SIGNUP_URL = 'https://lite.geofleet.ai/signup';
/** Sales calendar used by "Book a demo" / "Talk to us" buttons. */
export const DEMO_URL = 'https://meetings.hubspot.com/aditya145';
